import { useCallback, useState } from 'react';
import { NavigableTreeNode, TreeNode } from '../types';
import {
  transformNodeToNavigable,
  updateNodeRecursive,
} from '../utils/treeUtils';

/**
 * This hook is used to create and manage the tree nodes for the tree view
 * navigation. It takes the nodes and the currently active node id and returns
 * the tree node structure that is used by the tree view navigation components.
 * @param nodes The nodes to create the tree view from.
 * @param currentNodeId The currently active node id.
 */
export default function useTreeNodes(
  nodes: TreeNode[],
  currentNodeId?: number,
) {
  const [treeNodes, setTreeNodes] = useState<NavigableTreeNode[]>(() => {
    return nodes.map((node) => transformNodeToNavigable(node, currentNodeId));
  });

  const updateTreeNode = useCallback(
    (nodeId: number, updates: Partial<NavigableTreeNode>) => {
      setTreeNodes((prevNodes) =>
        updateNodeRecursive(prevNodes, nodeId, updates),
      );
    },
    [],
  );

  return {
    treeNodes,
    updateTreeNode,
  };
}
